export default {
    computed: {
        // store getters
        customerCorporation() { return this.$store.getters.corporation },
        customer() { return this.$store.getters.customer },
        customerSettings() { return this.$store.getters.customerSettings },
        billingSettings() { return this.$store.getters.customerBillingSettings },
        billingAddress() { return this.$store.getters.customerBillingAddress },
        billingContact() { 
            let contactProperties = ['contactEmail', 'contactFirstName', 'contactName', 'contactPhone', 'locale'];
            return _.pick(this.billingSettings, ...contactProperties);
        },
        customerAccounts() { return this.$store.getters.customerAccounts },
        customerSubscribedProducts() { return this.$store.getters.customerSubscribedProducts },
        customerCreditCard() { return !_.isEmpty(this.$store.getters.customerCreditCard) ? this.$store.getters.customerCreditCard : false },
        // computed
        activeCustomerAccounts() { return this.customerAccounts.filter(account => !account.locked && !account.user.locked) },
        customerServiceStartDate() { return this.customerServiceStartDateObj ? this.customerServiceStartDateObj.toISOString() : false },
        customerServiceEndDate() { return this.customerServiceEndDateObj ? this.customerServiceEndDateObj.toISOString() : false },
        customerServiceStartDateObj() { return this.billingSettings.serviceStartDate ? moment(this.billingSettings.serviceStartDate) : false },
        customerServiceEndDateObj() { return this.billingSettings.serviceEndDate ? moment(this.billingSettings.serviceEndDate) : false },
    },
    methods: {
        // store define dispatchers
        setCustomerCorporation(data) { return this.$store.dispatch(`defineCorporation`, data); },
        setCustomer(data) { return this.$store.dispatch(`defineCustomer`, data); },
        setBillingSettings(data) { return this.$store.dispatch(`defineCustomerBillingSettings`, data); },
        setCustomerSettings(data) { return this.$store.dispatch(`defineCustomerSettings`, data); },
        setBillingAddress(data) { 
            if (!data) return;
            return this.$store.dispatch(`defineCustomerBillingAddress`, data); 
        },
        setCustomerAccounts(data) { return this.$store.dispatch(`defineCustomerAccounts`, data); },
        setCustomerSubscribedProducts(data) { return this.$store.dispatch(`defineCustomerSubscribedProducts`, data); },
        setCustomerCreditCard(data) { return this.$store.dispatch(`defineCustomerCreditCard`, data); },
        setBillingContact(data) { return this.setBillingSettings({ ...this.billingSettings, ...data }); },
        // getters
        getCustomerSubscribedProduct(product) { return this.customerSubscribedProducts.find(c => c.code === product.code) },
        isProductSubscribedByCustomer(product) { return !!this.getCustomerSubscribedProduct(product) },
    },
}
